export const FREE_ACCESS_MODULE = ['PROFILE'];

export default FREE_ACCESS_MODULE;
